import { z } from "zod";

export const confirmationSchema = (expectedText?: string) => z.object({
  confirmation: expectedText
    ? z.string().trim().refine((value) => value === expectedText.trim(), `Type “${expectedText}” to confirm.`)
    : z.string().default(""),
});

export type ConfirmationValues = z.infer<ReturnType<typeof confirmationSchema>>;
